/* eslint-disable @typescript-eslint/no-explicit-any */
// import Select, { createFilter } from "react-select";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ListModel } from "../../../app/models/list-model";
import "./custom-select.scss";

/* eslint-disable-next-line */
export interface CustomSelectProps {
  //react-hook-form props
  field: any;
  register?: any;
  getFieldState?: any;
  formState?: any;
  errors?: any;
  //select props
  name: string;
  label?: string;
  placeholder?: string;
  assistiveText?: string;
  isMultiple: boolean;
  options: Array<ListModel>;
  required?: boolean;
  selectRef?: any;
  isClearable?: boolean;
  disabled?: boolean;
  hideSelectedValues?: boolean;
  handleChangeOption?: any;
  handleCreate?: (value: string) => void;
  showAssistiveTextAlways?: boolean;
  value?: any;
}

export function CustomSelect(props: CustomSelectProps) {
  const { isDirty, isTouched } = props.getFieldState(
    props.name,
    props.formState
  );

  return (
    <div className="select-container">
      {props.options && (
        <>
          <FormControl required={props.required} fullWidth>
            <InputLabel
              id="demo-simple-select-required-label"
              className="custom-label"
            >
              {props.label}
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id={props.name}
              label="Rol"
              {...props.field}
              placeholder=""
              disabled={props.disabled}
              value={props.value ?? props.field.value ?? ""}
              // onChange={(val: any) => {
              //   !props.isMultiple
              //     ? props.field.onChange(val?.value)
              //     : props.field.onChange(val.map((c: ListModel) => c.value));

              //   props.handleChangeOption && props.handleChangeOption(val);
              // }}
              // ref={props.selectRef ? props.selectRef : null}
              // isClearable={
              //   props.isClearable !== undefined ? props.isClearable : true
              // }
              // isDisabled={props.disabled}
              // filterOption={createFilter({
              //   ignoreCase: true,
              //   ignoreAccents: true,
              //   matchFrom: "any",
              //   stringify: (option: any) => `${option.label}`,
              //   trim: true,
              // })}
            >
              {props.options.map((o) => {
                return (
                  <MenuItem key={o.value} value={o.value}>
                    {o.label}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          {props.assistiveText &&
            (isTouched || isDirty || props.showAssistiveTextAlways) && (
              <p className="assistive-text">{props.assistiveText}</p>
            )}

          {props.errors && props.errors[props.name] && (
            <p className="error">
              {props.errors[props.name]?.message?.toString()}
            </p>
          )}
        </>
      )}
    </div>
  );
}

export default CustomSelect;
